<ng-container *ngIf="!rowData?.channel_details && showDeleteAction">
  <a href="javascript:" class="text-link no-underline" class="pointer" ngbTooltip="Delete" (click)="onTrashClick()">
    <i class="nxticon-delete-new nxt-font-20"></i>
  </a>
</ng-container>

<ng-container *ngIf="rowData?.channel_details?.type === 'Email'">
  <span class="send-email" (click)="showEmailPopup()" ngbTooltip="Send invoice" *ngIf="rowData?.payment_status?.status === 'Payment successful'">
    <i class="nxticon-invoice font-large"></i>
  </span>
  <span class="send-email disabled" *ngIf="rowData?.payment_status?.status !== 'Payment successful'">
    <i class="nxticon-invoice font-large"></i>
  </span>
</ng-container>

